import { posthog } from 'posthog-js';
import { getPostHogFallbackConfig } from '~/lib/config/posthog';

export class PostHogManager {
  private static instance: PostHogManager;
  private isInitialized = false;
  private useProxy = false;
  private fallbackAttempted = false;

  private constructor() {
    // Private constructor for singleton pattern
  }

  static getInstance(): PostHogManager {
    if (!PostHogManager.instance) {
      PostHogManager.instance = new PostHogManager();
    }

    return PostHogManager.instance;
  }

  async initialize(posthogKey: string): Promise<boolean> {
    if (this.isInitialized) {
      return true;
    }

    try {
      console.log('[PostHog Manager] Initializing with direct PostHog connection (proxy disabled)');

      const config = getPostHogFallbackConfig();
      posthog.init(posthogKey, config);
      this.isInitialized = true;
      this.fallbackAttempted = false;
      this.useProxy = false;
      console.log('[PostHog Manager] PostHog initialized successfully with direct connection');
      return true;
    } catch (error) {
      console.error('[PostHog Manager] Failed to initialize PostHog:', error);
      return false;
    }
  }

  // Method to manually switch to direct connection
  switchToDirect(): void {
    if (this.isInitialized) {
      console.log('[PostHog Manager] Direct connection already in use');
    }
  }

  // Method to manually switch back to proxy
  switchToProxy(): void {
    console.warn('[PostHog Manager] Proxy support disabled - keeping direct connection');
  }

  private reinitialize(): void {
    if (this.isInitialized) {
      const posthogKey = (window as any).ENV?.POSTHOG_KEY;

      if (posthogKey) {
        posthog.reset();
        this.isInitialized = false;
        this.fallbackAttempted = false;
        this.initialize(posthogKey);
      }
    }
  }

  // Get current connection status
  getConnectionStatus(): { isInitialized: boolean; useProxy: boolean; fallbackAttempted: boolean } {
    return {
      isInitialized: this.isInitialized,
      useProxy: this.useProxy,
      fallbackAttempted: this.fallbackAttempted,
    };
  }

  // Check if proxy is working
  async checkProxyHealth(): Promise<boolean> {
    return false;
  }

  // Proxy monitoring intentionally disabled (proxy removed)
}

// Export singleton instance
export const posthogManager = PostHogManager.getInstance();
